<script setup lang="ts">
const props = defineProps<{
  model: any
  imageSize?: 'sm' | 'md' | 'lg'
}>()

const imageSizeClassMap = {
  sm: 'max-w-20',
  md: 'max-w-30',
  lg: 'max-w-50',
}

const imageWidthClass = imageSizeClassMap[props.imageSize || 'md']
</script>

<template>
  <ULink
    :to="useCmsUrl(model?.logoLink?.value)"
    :locale="false"
    class="flex flex-col items-center justify-items-start text-primary w-full"
  >
    <NuxtImg
      v-if="model?.aprimoImage?.url"
      provider="fastlyAprimo"
      :src="model.aprimoImage.url"
      fit="contain"
      class="w-full h-auto"
      :class="imageWidthClass"
      :alt="model?.imageAltText.value"
      :width="model.aprimoImage.width ?? 120"
      :height="model.aprimoImage.height ?? 120"
      loading="lazy"
    />
    <div class="text-[15px] py-2.5 underline font-semibold sm:text-xl">
      {{ model?.label?.value }}
    </div>
  </ULink>
</template>
